import { Link } from "react-router-dom";
import { Calendar, ClipboardCheck, CalendarClock, AlertTriangle, Bell } from "lucide-react";

export default function WeeklySnapshot({ snapshot, briefingPreview }) {
  const items = [
    { k: "upcoming", label: "Upcoming events", value: snapshot?.upcoming_events ?? 0, Icon: Calendar, tint: "bg-[var(--fcc-emma)]" },
    { k: "tasks", label: "Tasks due", value: snapshot?.tasks_due ?? 0, Icon: ClipboardCheck, tint: "bg-[var(--fcc-green-soft)]" },
    { k: "deadlines", label: "Deadlines", value: snapshot?.deadlines ?? 0, Icon: CalendarClock, tint: "bg-[var(--fcc-noah)]" },
    { k: "conflicts", label: "Conflicts", value: briefingPreview?.conflict_count ?? 0, Icon: AlertTriangle, tint: "bg-[var(--fcc-red-soft)]" },
    { k: "actions", label: "Action items", value: snapshot?.action_items_total ?? 0, Icon: Bell, tint: "bg-[var(--fcc-cream-2)]" },
  ];
  return (
    <section data-testid="weekly-snapshot" className="fcc-card p-5 sm:p-6">
      <div className="flex items-end justify-between flex-wrap gap-3 mb-4">
        <div>
          <p className="label-overline">This week</p>
          <h3 className="font-display text-xl text-[var(--fcc-ink)] mt-1">At a glance, next 7 days</h3>
        </div>
        <Link to="/app/briefing" className="text-sm font-semibold text-[var(--fcc-green)]" data-testid="weekly-snapshot-briefing-link">Full briefing →</Link>
      </div>
      <ul className="grid grid-cols-2 sm:grid-cols-5 gap-3">
        {items.map((it) => (
          <li key={it.k} data-testid={`snapshot-${it.k}`} className="rounded-xl border border-[var(--fcc-border)] p-3.5 bg-white">
            <span className={`inline-flex w-8 h-8 rounded-lg items-center justify-center ${it.tint}`}>
              <it.Icon className="w-3.5 h-3.5 text-[var(--fcc-green)]" />
            </span>
            <p className="text-2xl font-display text-[var(--fcc-ink)] mt-2.5 leading-none">{it.value}</p>
            <p className="text-[10px] uppercase tracking-widest text-[var(--fcc-muted)] mt-1.5">{it.label}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}
